import {useRef} from "react";

import {FieldErrorType} from "~/model/helperTypes/Errors";

export const useFormBeenSubmitted = (submitLoading: boolean, backendErrors: FieldErrorType[] | null): [boolean] => {
  const prevLoadingRef = useRef(submitLoading);
  const hasBeenSubmittedRef = useRef(false);

  // Detect loading → not-loading transition synchronously during render
  if (prevLoadingRef.current && !submitLoading) {
    hasBeenSubmittedRef.current = true;
  }
  prevLoadingRef.current = submitLoading;

  const isFormBeenSubmittedSuccessfully = submitLoading || (hasBeenSubmittedRef.current && !backendErrors?.length);

  return [isFormBeenSubmittedSuccessfully];
};
